import React from 'react';
import { Row, Col } from 'react-bootstrap';
import Helper from './Helper';

interface FormPageTitleProps {
  title: string;
  helperContent?: string;
}

/** Заголовок страницы формы с опциональной подсказкой */
export const FormPageTitle: React.FC<FormPageTitleProps> = ({ title, helperContent }) => (
  <Row className="mx-0 py-3">
    <Col xs={12} className="d-flex align-items-center flex-wrap gap-2 justify-content-center">
      <h1 className="my-2 mb-0 text-center">{title}</h1>
      {helperContent && <Helper content={helperContent} />}
    </Col>
  </Row>
);

export default FormPageTitle;
